import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import * as firebase from 'firebase'

import _ from 'lodash'

import Dialog from 'material-ui/Dialog'

import CircularProgress from 'material-ui/CircularProgress'

import AllMaterialsHeader from './AllMaterialsHeader'
import MaterialsGroup from './MaterialsGroup'

class AllMaterialsScreen extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    jobName: PropTypes.string,
    teamMembers: PropTypes.array.isRequired,
    materialsListDbPath: PropTypes.string.isRequired,
    onRequestClose: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.listener = null
    this.state = {
      mode: 'date',
      totalPrice: 0
    }
  }

  componentWillMount() {
    if (this.props.open) {
      this.attachMaterialsListener()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open) {
      this.attachMaterialsListener()
    }
    else {
      this.detachMaterialsListener()
    }
  }

  componentWillUnmount() {
    this.detachMaterialsListener()
  }

  attachMaterialsListener = () => {
    if (!this.listener) {
      this.listener = firebase.database()
        .ref(this.props.materialsListDbPath)
        .on('value', this.onMaterialsListValue)
    }
  }

  detachMaterialsListener = () => {
    if (this.listener) {
      firebase.database()
        .ref(this.props.materialsListDbPath)
        .off('value', this.listener)
      this.listener = null
    }
  }

  getMaterialCost = material => {
    const quantity = material.quantity ? parseFloat(material.quantity.trim()) : 0
    const cost = material.cost ? parseFloat(material.cost.trim()) : 0
    if (!isNaN(quantity) && !isNaN(cost)) {
      return quantity * cost
    }
    return 0
  }

  getTotalPrice = materials => {
    return _.reduce(_.filter(materials, m => !m.delete), (acc, m) => acc + this.getMaterialCost(m), 0)
  }

  onMaterialsListValue = snapshot => {
    const materials = snapshot && snapshot.val() || {}
    this.setState({
      materials,
      totalPrice: this.getTotalPrice(materials)
    })
  }

  handleAllMaterialsDialogCloseRequested = () => {
    this.props.onRequestClose()
  }

  handleModeSelectorChanged = mode => {
    this.setState({
      mode
    })
  }

  getMaterialsByDate = () => {
    return _.groupBy(this.state.materials, 'jobDateStr')
  }

  sortDatesKeys = dateGrouping => {
    return _.reverse(_.keys(dateGrouping).sort())
  }

  getMaterialsByWorker = () => {
    return _.groupBy(this.state.materials, 'userId')
  }

  sortWorkerKeys = workerGrouping => {
    const keys = []
    for (const userId in workerGrouping) {
      const member = this.props.teamMembers.find(member => member.userId === userId)
      if (member) {
        keys.push({ userId, name: member.displayName })
      }
    }
    return _.sortBy(keys, 'name')
  }

  render() {
    const grouping = this.state.materials
      ? (this.state.mode === 'date'
        ? this.getMaterialsByDate()
        : this.getMaterialsByWorker())
      : null
    return (
      <Dialog
        open={this.props.open}
        modal={false}
        autoScrollBodyContent={true}
        contentStyle={styles.container}
        bodyStyle={styles.body}
        onRequestClose={this.handleAllMaterialsDialogCloseRequested}>
        <AllMaterialsHeader
          mode={this.state.mode}
          jobName={this.props.jobName}
          totalPrice={this.state.totalPrice}
          onModeSelectorChanged={this.handleModeSelectorChanged}
          onRequestClose={this.handleAllMaterialsDialogCloseRequested} />
        <div style={styles.breakdown}>
          {
            this.state.materials
              ? (_.size(this.state.materials) === 0
                ? <div style={styles.zero}>No materials have been added for this job.</div>
                : (this.state.mode === 'date'
                  ? this.sortDatesKeys(grouping).map(date =>
                    <MaterialsGroup
                      key={date}
                      mode={this.state.mode}
                      header={date}
                      list={grouping[date]} />)
                  : this.sortWorkerKeys(grouping).map(pair =>
                    <MaterialsGroup
                      key={pair.userId}
                      mode={this.state.mode}
                      header={pair.name}
                      list={grouping[pair.userId]} />
                  )))
              : <CircularProgress style={styles.zero} thickness={2} color='#527da3' />
          }
        </div>
      </Dialog>
    )

  }

}

const styles = {
  body: {
    padding: 0
  },
  container: {
    borderRadius: 2,
    // This is a hack as there is a bug in Dialog's definition to properly
    // apply the border radius.
    overflow: 'auto'
  },
  breakdown: {
    maxHeight: 600,
    overflow: 'auto'
  },
  zero: {
    margin: 20,
    textAlign: 'center',
    color: 'rgb(117, 117, 117)'
  }
}

const mapStateToProps = (state) => ({
  teamMembers: state.firebase.team.members.value
})

export default connect(mapStateToProps)(AllMaterialsScreen)



// WEBPACK FOOTER //
// ./src/schedule/common/modules/materials/AllMaterialsScreen.js